module.exports = __webpack_public_path__ + "img/7.a0399ef2.webp";